import React from "react";

const AfishaBanner = ({ item }) => {
  return (
    <div className="afisha-banner">
      {/* {!bannerWidth && (
        <div className='text border-radius'>
          <p style={{ fontSize: '36px' }}>{item.title}</p>
        </div>
      )} */}
      <div className="afisha-banner_image">
        <img
          className="border-radius afisha-banner_image--desktop"
          src={`${process.env.REACT_APP_IMG_SERVER}/img/8259/original`}
          alt={item.title}
        />
        <img
          className="border-radius afisha-banner_image--mobile"
          src={`${process.env.REACT_APP_IMG_SERVER}/img/8259/original`}
          alt={item.title}
        />
      </div>
      <div className="afisha-banner_info" />
      {/* <div className='text border-radius'>
        {!bannerWidth ? (
          <p
            dangerouslySetInnerHTML={{ __html: item.description }}
            style={{ fontSize: '18px' }}
          />
        ) : (
          <React.Fragment>
            <p style={{ fontSize: '27px', marginBottom: '15px' }}>
              {item.title}
            </p>
            <p
              dangerouslySetInnerHTML={{ __html: item.description }}
              style={{ fontSize: '14px' }}
            />
          </React.Fragment>
        )}
      </div> */}
    </div>
  );
};

export default AfishaBanner;



// WEBPACK FOOTER //
// ./src/components/Events/AfishaBanner.js